import moment from 'moment';
import { ServiceTrip, TaipJumpEventVm, TaipReportVm } from '../../types/servicePageTypes';

type ReportColumn<TRow> = {
    header: string;
    getter: (row: TRow) => string | number | null | undefined;
};

export function toReportRow<TRow>(reportDef: ReportColumn<TRow>[], row: TRow): object {
    const reportRow: { [column: string]: string | number | null | undefined } = {};
    for (const colDef of reportDef) {
        const v = colDef.getter(row);
        if (v !== undefined)
            reportRow[colDef.header] = v;
    }
    return reportRow;
}

export const UnmatchedTripsReportDef: ReportColumn<ServiceTrip>[] = [
    {
        header: 'Trip Id',
        getter: (e: ServiceTrip) => `${e.tripId}`,
    },
    {
        header: 'Scheduled Start',
        getter: (e: ServiceTrip) => moment.parseZone(e.scheduledStart).format('YYYY-MM-DD hh:mm A'),
    },
    {
        header: 'Scheduled End',
        getter: (e: ServiceTrip) => moment.parseZone(e.scheduledEnd).format('YYYY-MM-DD hh:mm A'),
    },
    {
        header: 'Route Name',
        getter: (e: ServiceTrip) => `${e.routeName}`,
    },
    {
        header: 'Direction Variant Name',
        getter: (e: ServiceTrip) => `${e.directionVariantName}`,
    },
];

export const UnmatchedTripsReportHeader = UnmatchedTripsReportDef.map(column => column.header);



export const TaipReportsDef: ReportColumn<TaipReportVm>[] = [
    {
        header: 'Problem Type',
        getter: (e: TaipReportVm) => `${e.problemType}`,
    },
    {
        header: 'Timestamp',
        getter: (e: TaipReportVm) => moment.parseZone(e.timestamp).format('YYYY-MM-DD hh:mm A'),
    },
    {
        header: 'Vehicle Id',
        getter: (e: TaipReportVm) => `${e.vehicleId}`,
    },
    {
        header: 'IP Address',
        getter: (e: TaipReportVm) => `${e.ipAddress}`,
    },
    {
        header: 'Message',
        getter: (e: TaipReportVm) => `${e.message}`,
    },
];

export const TaipReportsHeader = TaipReportsDef.map(column => column.header);

export const TaipJumpReportsDef: ReportColumn<TaipJumpEventVm>[] = [
    {
        header: 'Detection Time',
        getter: (event: TaipJumpEventVm) => moment.parseZone(event.detectedAt).format('YYYY-MM-DD hh:mm A'),
    },
    {
        header: 'Vehicle ID',
        getter: (event: TaipJumpEventVm) => `${event.vehicleId}`,
    },
    {
        header: 'Previous Lat',
        getter: (event: TaipJumpEventVm) => event.previousLatitude,
    },
    {
        header: 'Previous Lon',
        getter: (event: TaipJumpEventVm) => event.previousLongitude,
    },
    {
        header: 'Current Lat',
        getter: (event: TaipJumpEventVm) => event.currentLatitude,
    },
    {
        header: 'Current Lon',
        getter: (event: TaipJumpEventVm) => event.currentLongitude,
    },
    {
        header: 'Distance (m)',
        getter: (event: TaipJumpEventVm) => Math.round(event.distanceMeters),
    },
    {
        header: 'Time Diff (s)',
        getter: (event: TaipJumpEventVm) => Math.round(event.timeDifferenceSeconds),
    },
    {
        header: 'Previous IP',
        getter: (event: TaipJumpEventVm) => `${event.previousSourceIp}`,
    },
    {
        header: 'Current IP',
        getter: (event: TaipJumpEventVm) => `${event.currentSourceIp}`,
    },
    {
        header: 'IP Mismatch',
        getter: (event: TaipJumpEventVm) => (event.ipMismatch ? 'Yes' : 'No'),
    },
];

export const TaipJumpReportsHeader = TaipJumpReportsDef.map(column => column.header);
